import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useFetchLiveUrlMutation } from '../../queries/live/liveQueryHooks';
import { useFetchLivePlayMutationStore } from '../../stores/useFetchLivePlayMutationStore';
import useModalStore from '../../stores/useModalStore';
import useOldPlayerStore from '../../stores/useOldPlayerStore';
import { createBlindOffUpdate } from '../centrifuge/messageUpdates';
const RETRY_COUNT = 7;

/**
 * SocketPayload - CastResume
 */
function useCastResume() {
  const $ = _c(12);
  const {
    pushModal
  } = useModalStore();
  const {
    player
  } = useOldPlayerStore();
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const setPlayInfo = useFetchLivePlayMutationStore(_temp2);
  const [fetchNewUrlCount, setFetchNewUrlCount] = useState(0);
  let t0;
  if ($[0] !== player) {
    t0 = {
      onSuccess: data => {
        if (!player) {
          return;
        }
        player.src(data.PlayList.hls[0].url);
        player.play();
        player.muted(false);
      },
      retry: false
    };
    $[0] = player;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutate: fetchLiveUrl
  } = useFetchLiveUrlMutation(t0);
  let t1;
  if ($[2] !== fetchLiveUrl || $[3] !== fetchNewUrlCount || $[4] !== playInfo || $[5] !== player || $[6] !== pushModal || $[7] !== setPlayInfo) {
    t1 = () => {
      if (fetchNewUrlCount < 1 || !player) {
        return;
      }
      const isPlaying = !player.paused() && !player.ended() && !player.seeking() && player.readyState() >= 3;
      if (isPlaying && playInfo) {
        setPlayInfo(createBlindOffUpdate(playInfo));
        setFetchNewUrlCount(0);
        return;
      }
      if (fetchNewUrlCount > RETRY_COUNT) {
        pushModal({
          type: "CONFIRM_CANCEL_MODAL",
          options: {
            description: "\uC2A4\uD2B8\uB9AC\uBC0D \uC5F0\uACB0\uC774 \uC6D0\uD65C\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.\n\uC0C8\uB85C\uACE0\uCE68 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            onClick: _temp3
          }
        });
        return;
      }
      const randomIntervalTime = Math.floor((Math.random() * 7 + 3) * 1000);
      const fetchTimeOut = setTimeout(() => {
        if (!playInfo?.media.code) {
          return;
        }
        fetchLiveUrl({
          mediaCode: playInfo.media.code,
          token: playInfo.chatServer.token,
          t: playInfo.chatServer.t
        });
        setFetchNewUrlCount(_temp4);
      }, randomIntervalTime);
      return () => clearTimeout(fetchTimeOut);
    };
    $[2] = fetchLiveUrl;
    $[3] = fetchNewUrlCount;
    $[4] = playInfo;
    $[5] = player;
    $[6] = pushModal;
    $[7] = setPlayInfo;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== fetchNewUrlCount) {
    t2 = [fetchNewUrlCount];
    $[9] = fetchNewUrlCount;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    const startRetry = () => {
      setFetchNewUrlCount(1);
    };
    t3 = {
      startRetry
    };
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
function _temp4(prev) {
  return prev + 1;
}
function _temp3() {
  window.location.reload();
}
function _temp2(state_0) {
  return state_0.setData;
}
function _temp(state) {
  return state.data;
}
export default useCastResume;